export { MiniCard as default } from './MiniCard';
